import { IHotel } from "./index";
import {HotelChain} from "@/models/HotelChain";
import {HotelCategory} from "@/models/HotelCategory";
import {Currency} from "@/models/Currency";

const mutations = {
  SET_TABLE_DATA: (state, data: Array<IHotel>) => {
    state.tableData = data;
  },
  SET_EMPTY_TABLE_DATA: (state) => {
    state.tableData = [];
  },
  SET_HOTEL_DETAILS: (state, data: IHotel) => {
    state.hotelDetails = data;
  },
  SET_HOTEL_CHAINS: (state, data: HotelChain[]) => {
    state.hotelChains = data;
  },
  SET_HOTEL_CATEGORY: (state, data: HotelCategory[]) => {
    state.hotelCategories = data;
  },
  SET_CURRENCIES: (state, data: Currency[]) => {
    state.currencies = data;
  },
  CLEAR_HOTEL_DATA: (state, data: IHotel) => {
    state.hotelDetails = data;
  },
  SET_LOADING_START: (state) => {
    state.isLoading = true;
  },
  SET_LOADING_FINISHED: (state) => {
    state.isLoading = false;
  },
  SET_SELECTED_FILE: (state, data) => {
    state.selectedLogo = data;
  },
  CLEAR_SELECTED_FILE: (state) => {
    state.selectedLogo = {};
    state.hotelDetails.LogoUrl = null;
  },
  SET_SNACKBAR_VISIBILITY: (state, val: boolean) => {
    state.isSnackBarVisible = val;
  },
  SET_SNACKBAR_MESSAGE: (state, message: string) => {
    state.snackbarMsg = message;
  },
  SET_SNACKBAR_STATUS: (state, status: string) => {
    state.snackbarStatus = status;
  },
  CLEAR_SNACKBAR: (state) => {
    state.isSnackBarVisible = false;
  },
};

export default mutations;
